<template>
  <v-app app>
    <v-navigation-drawer
      v-model="show_drawer"
      :permanent="!$vuetify.breakpoint.xsOnly"
      style="box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.1)"
      app
    >
      <div class="d-flex align-center">
        <img
          src="/logo.svg"
          width="64"
          height="64"
          style="margin-right: 10px"
        />
        КАБИНЕТ БЛОГЕРА
      </div>
      <v-list class="pa-0">
        <v-list-item-group>
          <ns-menu-item
            icon="mdi-earth"
            :to="{ name: 'admin-site-news' }"
            label="Блог"
            :active="$route.name === 'admin-site-news'"
          />
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main style="background-color: #f0f8f6" class="mb-6">
      <v-container fluid class="ma-0 pa-0">
        <v-toolbar height="64x" flat style="z-index: 1">
          <v-app-bar-nav-icon
            v-if="$vuetify.breakpoint.xsOnly"
            @click.stop="show_drawer = !show_drawer"
          ></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <v-toolbar-items class="d-flex">
            <v-expansion-panels hover flat accordion>
              <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" style="min-height: 100%">
                  <div class="d-flex justify-center align-center pa-0">
                    <v-icon color="primary">mdi-account-circle</v-icon>
                    <span
                      class="user-email text-truncate"
                      style="min-width: 40px"
                      >{{ user.email }}</span
                    >
                  </div>
                  <template v-slot:actions>
                    <v-icon color="primary"> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  id="expansion-panel-content-1"
                  style="position: absolute; right: 0; top: 100%; z-index: 10"
                >
                  <div class="d-flex flex-column">
                    <v-btn
                      depressed
                      color="white"
                      @click="showChangePasswordModal = true"
                      class="pa-0 flex-grow-1"
                    >
                      <div>
                        <v-icon color="primary">mdi-lock-reset</v-icon>
                        Сменить пароль
                      </div>
                    </v-btn>
                    <v-divider></v-divider>
                    <v-btn
                      depressed
                      color="white"
                      @click="doLogout"
                      class="pa-0 flex-grow-1"
                    >
                      <div>
                        <v-icon color="primary">mdi-exit-run</v-icon>
                        Выход
                      </div>
                    </v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-toolbar-items>
        </v-toolbar>
      </v-container>
      <v-container class="px-2 px-sm-10" fluid app>
        <slot />
      </v-container>
    </v-main>
    <v-dialog v-model="showChangePasswordModal" max-width="500">
      <v-card>
        <v-card-title>Смена пароля</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="changePassword">
            <v-text-field
              v-model="currentPassword"
              label="Текущий пароль"
              :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showCurrentPassword ? 'text' : 'password'"
              @click:append="showCurrentPassword = !showCurrentPassword"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              label="Новый пароль"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPassword ? 'text' : 'password'"
              @click:append="showNewPassword = !showNewPassword"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPasswordConfirm"
              label="Повторить новый пароль"
              :append-icon="showNewPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPasswordConfirm ? 'text' : 'password'"
              @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
              required
            ></v-text-field>
            <div v-if="changePasswordMessage">{{ changePasswordMessage }}</div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showChangePasswordModal = false">Отмена</v-btn>
          <v-btn color="primary" @click="changePassword">Сменить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="3000" top color="success">
      {{ snackbarText }}
    </v-snackbar>
    <v-footer></v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NsMenuItem from "@/components/NsMenuItem";
import NSApi from "@/api/NSApi";

export default {
  name: "BloggerLayout",
  components: { NsMenuItem },
  data() {
    return {
      showChangePasswordModal: false,
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      changePasswordMessage: "",
      showCurrentPassword: false,
      showNewPassword: false,
      showNewPasswordConfirm: false,
      show_drawer: false,
      snackbar: false,
      snackbarText: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["doLogout"]),
    async changePassword() {
      this.changePasswordMessage = "";
      if (this.newPassword !== this.newPasswordConfirm) {
        this.changePasswordMessage = "Пароли не совпадают";
        return;
      }

      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (!passwordRegex.test(this.newPassword)) {
        this.changePasswordMessage =
          "Новый пароль не соответствует требованиям. Пароль должен содержать минимум 8 символов, буквы, цифры и специальные символы.";
        return;
      }

      try {
        await NSApi.instance.changePassword(
          this.currentPassword,
          this.newPassword
        );
        this.showChangePasswordModal = false;
        this.currentPassword = "";
        this.newPassword = "";
        this.newPasswordConfirm = "";
        this.snackbarText = "Пароль успешно изменен";
        this.snackbar = true;
      } catch (error) {
        this.changePasswordMessage =
          error.response?.data?.message || "Произошла ошибка";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-email {
  max-width: 200px;
}
#expansion-panel-content-1::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-icon {
  color: #23919e !important;
}

.v-list-item .v-list-item__icon .v-icon {
  color: #23919e !important;
}

@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .user-email {
    max-width: 50px;
  }
}
</style>
